/**
 * ── 변경사항 (ECHO 톤) ──
 * 체크박스 3개 → 세그먼트 버튼 (하/중/상 단일 선택이므로 체크박스가 오히려 혼란)
 * 선택 시 해당 난이도 설명을 힌트 박스로 표시 (기존 텍스트 그대로 사용)
 */
const SyntaxAnalysisSelection = ({
  allTypes,
  selectedTypes,
  setSelectedTypes,
}) => {
  const levels = allTypes.find((t) => t.key === "syntax_analysis").levels;
  const current = selectedTypes.find(
    (t) => t.key === "syntax_analysis"
  ).level;

  const handleLevelClick = (level) => {
    setSelectedTypes((prev) =>
      prev.map((item) =>
        item.key === "syntax_analysis" ? { ...item, level } : item
      )
    );
  };

  return (
    <>
      <div className="ws-seg">
        {levels.map((level) => (
          <button
            key={level.key}
            className={`ws-seg-btn${current.key === level.key ? " active" : ""}`}
            onClick={() => setSelectedTypes && handleLevelClick(level)}
          >
            {level.value}
          </button>
        ))}
      </div>
      {current.key !== "" && (
        <div className="ws-hint" style={{ marginTop: "10px" }}>
          {current.text}
        </div>
      )}
    </>
  );
};

export default SyntaxAnalysisSelection;
